import LogoMark from "./LogoMark.jsx";
import { useSiteContent, mediaUrl } from "@/content/ContentContext.jsx";

export const BrandLogo = ({ size = 44, rounded = "rounded-xl", fallbackBg = "bg-brand", className = "", testid }) => {
  const { content } = useSiteContent();
  const logo = content.brand?.logo;

  if (logo) {
    return (
      <span
        className={`flex items-center justify-center overflow-hidden bg-white ${rounded} ${className}`}
        style={{ height: size, width: size }}
        data-testid={testid}
      >
        <img src={mediaUrl(logo)} alt="Angukumaran Farmhouse logo" className="h-full w-full object-contain p-1" />
      </span>
    );
  }
  return (
    <span className={`flex items-center justify-center ${fallbackBg} ${rounded} ${className}`} style={{ height: size, width: size }} data-testid={testid}>
      <LogoMark size={Math.round(size * 0.72)} variant="light" />
    </span>
  );
};

export default BrandLogo;
